/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InvoiceSearchGroupResponse } from './InvoiceSearchGroupResponse';
import {
    InvoiceSearchGroupResponseFromJSON,
    InvoiceSearchGroupResponseFromJSONTyped,
    InvoiceSearchGroupResponseToJSON,
    InvoiceSearchGroupResponseToJSONTyped,
} from './InvoiceSearchGroupResponse';

/**
 * 
 * @export
 * @interface InvoiceSearchResponse
 */
export interface InvoiceSearchResponse {
    /**
     * 
     * @type {Array<InvoiceSearchGroupResponse>}
     * @memberof InvoiceSearchResponse
     */
    groups?: Array<InvoiceSearchGroupResponse>;
    /**
     * 
     * @type {boolean}
     * @memberof InvoiceSearchResponse
     */
    hasMore?: boolean;
}

/**
 * Check if a given object implements the InvoiceSearchResponse interface.
 */
export function instanceOfInvoiceSearchResponse(value: object): value is InvoiceSearchResponse {
    return true;
}

export function InvoiceSearchResponseFromJSON(json: any): InvoiceSearchResponse {
    return InvoiceSearchResponseFromJSONTyped(json, false);
}

export function InvoiceSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): InvoiceSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'groups': json['groups'] == null ? undefined : ((json['groups'] as Array<any>).map(InvoiceSearchGroupResponseFromJSON)),
        'hasMore': json['hasMore'] == null ? undefined : json['hasMore'],
    };
}

export function InvoiceSearchResponseToJSON(json: any): InvoiceSearchResponse {
    return InvoiceSearchResponseToJSONTyped(json, false);
}

export function InvoiceSearchResponseToJSONTyped(value?: InvoiceSearchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'groups': value['groups'] == null ? undefined : ((value['groups'] as Array<any>).map(InvoiceSearchGroupResponseToJSON)),
        'hasMore': value['hasMore'],
    };
}

